import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from '../auth';
import { adminReducer } from '../admin';
import { systemReducer } from '../system';
import { noteReducer } from '../notes';
import { commentReducer } from '../comments';
import { aiNoteReducer } from '../aiNote';
import { aiTransformReducer } from '../aiTransform';
import { payrollReducer } from '../payroll';
import { permissionsReducer } from '../permissions';
import { roleReducer } from '../role';
import { fundingSourceReducer } from '../fundingSource';
import { clientReducer } from '../client';
import { httpRequestsOnLoadReducer } from '../http_requests_on_load';
import { httpRequestsOnSuccessReducer } from '../http_requests_on_success';
import { httpRequestsOnErrorsReducer } from '../http_requests_on_errors';
import { availabilityScheduleReducer } from '../availabilitySchedule';
import { appointmentReducer } from '../appointment';
import { claimReducer, invoiceReducer, invoiceTxnReducer } from '../billing';
import { claimPaymentReducer, invoicePaymentReducer } from '../posting';
import { historyReducer } from '../history';
import { reportsReducer } from '../reports';
import { staffPayrollReducer } from '../staffPayroll';
import { notificationReducer } from '../notification';
import { analyticsReducer } from '../analytics';
import { dashboardReducer } from '../dashboard';
import { tagReducer } from '../tags';
import { formReducer } from '../form';
import { resourceReducer } from '../resource';
import {
    goalReducer,
    domainReducer,
    assessmentReducer,
    abcReducer,
    sessionReducer,
    eventsReducer,
    baselinesReducer,
    progressReportReducer,
    clinicalAnalyticsReducer,
} from '../clinical';
import { libraryReducer } from '../library';
import { fileReducer } from '../file';
import { chatReducer } from '../chat';
import { supervisionReducer } from '../supervision';
import { postedNoteReducer } from '../postedNote';
import { tasksReducer } from '../tasks';
import { versionsReducer } from '../versions';
import { tutorialVideosReducer } from '../tutorialVideos';
import { clientDiagnosisReducer } from '../clientDiagnosis';
import { wishlistReducer } from '../wishlist';
import { documentVersionReducer } from '../documentVersion';
import { mapReducer } from '../map';
import { userPreferencesReducer } from '../userPreferences';
import { signatureRequestReducer } from '../signatureRequest';

const initialState = {
    isLoading: false,
    error: false,
};

const globalReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};
export const appReducer = combineReducers({
    auth: authReducer,
    global: globalReducer,
    admins: adminReducer,
    permissions: permissionsReducer,
    roles: roleReducer,
    fundingSource: fundingSourceReducer,
    client: clientReducer,
    system: systemReducer,
    note: noteReducer,
    comments: commentReducer,
    aiNote: aiNoteReducer,
    aiTransform: aiTransformReducer,
    payroll: payrollReducer,
    availabilitySchedule: availabilityScheduleReducer,
    appointment: appointmentReducer,
    claim: claimReducer,
    invoice: invoiceReducer,
    invoiceTxn: invoiceTxnReducer,
    claimPayment: claimPaymentReducer,
    invoicePayment: invoicePaymentReducer,
    history: historyReducer,
    reports: reportsReducer,
    staffPayroll: staffPayrollReducer,
    notifications: notificationReducer,
    analytics: analyticsReducer,
    dashboard: dashboardReducer,
    tags: tagReducer,
    map: mapReducer,
    resource: resourceReducer,
    forms: formReducer,
    files: fileReducer,

    httpOnLoad: httpRequestsOnLoadReducer,
    httpOnSuccess: httpRequestsOnSuccessReducer,
    httpOnError: httpRequestsOnErrorsReducer,

    /** Clinical */
    goals: goalReducer,
    domains: domainReducer,
    assessment: assessmentReducer,
    abc: abcReducer,
    session: sessionReducer,
    evens: eventsReducer,
    baselines: baselinesReducer,
    progressReports: progressReportReducer,
    clinicalAnalytics: clinicalAnalyticsReducer,
    library: libraryReducer,
    chat: chatReducer,
    supervision: supervisionReducer,
    postedNote: postedNoteReducer,
    versions: versionsReducer,
    tutorialVideos: tutorialVideosReducer,
    clientDiagnosis: clientDiagnosisReducer,
    wishlist: wishlistReducer,
    /** End */

    /** Tasks */
    tasks: tasksReducer,

    /** Document Versioning */
    documentVersion: documentVersionReducer,

    /** Per-user UI state — saved grid filters */
    userPreferences: userPreferencesReducer,
    signatureRequest: signatureRequestReducer,
});
